import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BreakEvenChart from "./BreakEvenChart";
import ExpenseChart from "./ExpenseChart";
import FinancialChart from "./FinancialChart";
import FundChart from "./FundChart";
import NetProfitChart from "./NetProfitChart";
import RevenueGrowthChart from "./RevenueGrowthChart";
import RevenuesChart from "./RevenuesChart";
import ROIChart from "./ROIChart";
import SalesGrowthChart from "./SalesGrowthChart";
import SalesRevenueEbitdaChart from "./SalesRevenueEbitdaChart";

const PitchDB = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <Row className="normal-lh flex-wrap-items gx-5">
            <Col >
              <div className="flex-wrap-items primary-box small h-100">
                <div className="flex-wrap-items">
                  <img
                    src="/images/revenue_icon.png"
                    alt="icon"
                    className="md-icon img-icon"
                  />
                  <div>
                    <p className="para">Sales Revenues</p>
                    <p className="para fw-bold">$162,846,720,000</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col >
              <div className="flex-wrap-items primary-box small h-100">
                <div className="flex-wrap-items">
                  <img
                    src="/images/calculator_icon.png"
                    alt="icon"
                    className="md-icon img-icon"
                  />
                  <div>
                    <p className="para ">Operating Expenses</p>
                    <p className="para fw-bold">$44,785,749,600</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col >
              <div className="flex-wrap-items primary-box small h-100">
                <div className="flex-wrap-items">
                  <img
                    src="/images/profits_icon.png"
                    alt="icon"
                    className="md-icon img-icon"
                  />
                  <div>
                    <p className="para">Net Profits</p>
                    <p className="para fw-bold">$64,340,361,720</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">
            Financial Highlights
          </p>
          <div className="white-box pt-5 px-0 pb-0">
            <FinancialChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">
            Break-Even Revenues
          </p>
          <div className="white-box p-0">
            <BreakEvenChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">NET PROFIT /SALES</p>
          <div className="white-box p-3">
            <NetProfitChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">USE OF FUNDS</p>
          <div className="white-box p-5">
            <FundChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">EXPENSES SHARE</p>
          <div className="white-box p-5">
            <ExpenseChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">REVENUES BREAKUP</p>
          <div className="white-box p-2">
            <RevenuesChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">
            SALES CATEGORY GROWTH
          </p>
          <div className="white-box">
            <SalesGrowthChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">
            SALES REVENUE VS EBITDA
          </p>
          <div className="white-box">
            <SalesRevenueEbitdaChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">
            YEARLY REVENUES GROWTH
          </p>
          <div className="white-box">
            <RevenueGrowthChart />
          </div>
        </Container>
      </section>
      <section className="pb-5">
        <Container>
          <p className="section-subtitle  text-start mb-2">ROI</p>
          <div className="white-box">
            <ROIChart gradientColor="#3E3E3E" />
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchDB;
